/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UsersPerAreaOfInterest = {
    properties: {
        areaOfInterestId: {
            type: 'number',
            isRequired: true,
        },
        areaOfInterestCode: {
            type: 'string',
            isRequired: true,
        },
        userCount: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
